import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTravisciComponent } from './simple-icons-travisci.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTravisciComponent ],
    exports:      [ SimpleIconsTravisciComponent ],
    bootstrap:    []
})
export class SimpleIconsTravisciModule {}
